import EmailIcon from '@mui/icons-material/Email'
import { Box, Typography } from '@mui/material'

import { Links } from 'constants/Paths'

const emailIconContainerStyles = {
  width: 60,
  height: 60,
  flexShrink: 0,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #C6007E 0%, #471D7C 100%)',
  color: 'white',
}

export const ContactEmail = () => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
      <Box sx={emailIconContainerStyles}>
        <EmailIcon sx={{ fontSize: 30 }} />
      </Box>
      <Box>
        <Typography
          variant='body1'
          fontWeight='bold'
          sx={{ fontFamily: 'Goldplay-Bold', fontSize: '18px' }}>
          Email us
        </Typography>
        <Typography
          variant='body1'
          component='a'
          href={`mailto:${Links.supportEmail}`}
          sx={{
            fontFamily: 'Goldplay-Regular',
            fontSize: '18px',
            color: 'inherit',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}>
          {Links.supportEmail}
        </Typography>
      </Box>
    </Box>
  )
}
